<template>
	<div class="container">
		<div class="abstract">
			<img src="../../assets/imgs/smart.png" alt="">
			<div class="text">
				<p class="title">数字乡村</p>
				<p class="subTitle">Digital village</p>
			</div>
		</div>
		
		<div class="synopsis">
			<div class="text">
				<div class="line"></div>
				<p class="title">大棚系统简介</p>
				<p class="subTitle">System introduction</p>
			</div>
			<div class="content">
				赛通科技自主研发的大棚智能控制系统，可远程获取现场环境的空气温湿度、土壤水分温度、二氧化碳浓度、光照强度及视频图像，可以自动控制温室湿帘风机、喷淋滴灌、内外遮阳、顶窗侧窗、加温补光等设备。通过数据模型分析，合理地根据现场条件开启关闭设备，使作物始终处于生长的最佳环境！同时，用户还可以通过手机、触摸屏、计算机等信息终端向管理者推送实时监测信息、报警信息，实现现场环境的信息化、智能化远程管理。可减少人工成本，实现无人值守，精准调控，降低生产风险，提高农作物产量。
			</div>
			<img src="../../assets/imgs/dp1.png" alt="">
		</div>
		
		<div style="background: #F3F2F7;">
			<div class="architecture">
				<div class="text">
					<div class="line"></div>
					<p class="title">系统架构</p>
					<p class="subTitle">system architecture</p>
				</div>
				<img style="margin-top: 14px;" src="../../assets/imgs/dp2.png" alt="">
			</div>
		</div>
		
		<div class="system">
			<div class="text">
				<div class="line"></div>
				<p class="title">系统架构</p>
				<p class="subTitle">system architecture</p>
			</div>
			
			<div class="environment">
				<img src="../../assets/imgs/dp3.png" alt="">
				<div class="info">
					<p class="title">保持作物生长最佳环境</p>
					<div class="content">系统可提供60多种农业智能传感设备及智能控制设备，在线实时24小时连续的采集和记录监测点位的温度、湿度、光照、土壤温度、土壤湿度、CO2浓度等环境各项参数情况，以数字、图形和图像等多种方式进行实时显示和记录存储监测信息，监测点位可扩充多达上千个点。并合理地根据现场条件开启关闭设备，控制温室湿帘风机、喷淋滴灌、内外遮阳、顶窗侧窗、加温补光等设备。使作物始终处于生长的最佳环境！</div>
				</div>
			</div>
			
			<div class="control">
				<div class="info">
					<p class="title">远程监控，手机控制</p>
					<div class="content">用户可通过手机及电脑，远程在线查看监控点位的温湿度等参数的变化情况，还可以自动控制现场环境设备，实现远程控制灌溉，施肥，放风，遮阳等。省时省力自动化，一人可管理几百亩大棚。</div>
				</div>
				<img src="../../assets/imgs/dp4.png" alt="">
			</div>
		</div>
		
		<div style="background-color: #F4F8FF;">
			<div class="benefits">
				<div class="text">
					<div class="line"></div>
					<p class="title">效益对比</p>
					<p class="subTitle">Benefit comparison</p>
				</div>
				<img style="margin-top: 56px;" src="../../assets/imgs/dp5.png" alt="">
			</div>
		</div>
		
		<div class="plan">
			<div class="text">
				<div class="line"></div>
				<p class="title">智慧农业解决方案</p>
				<p class="subTitle">wisdom agriculture  solution</p>
			</div>
			
			<img style="margin-top: 33px;" src="../../assets/imgs/dp7.png" alt="">
		</div>
		
	</div>
</template>

<script>
	export default {
		data() {
			return {
				
			}
		},
		
		methods: {
			
		}
	}
</script>

<style scoped>
.abstract {
	position: relative;
}

.abstract img {
	width: 100%;
}

.abstract .text {
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	color: #fff;
	text-align: center;
}

.abstract .text .title {
	font-size: 40px;
	font-family: SourceHanSansCN-Medium, SourceHanSansCN;
	font-weight: 500;
	color: #FFFFFF;
}

.abstract .text .subTitle {
	font-size: 18px;
	font-family: SourceHanSansCN-Medium, SourceHanSansCN;
	font-weight: 500;
	color: #FFFFFF;
	text-transform: uppercase;
	margin-top: 43px;
}

.line {
	width: 35px;
	height: 5px;
	background: #245ECB
}

.title {
	height: 24px;
	font-size: 24px;
	font-family: SourceHanSansCN-Medium, SourceHanSansCN;
	font-weight: 500;
	color: #333333;
	margin: 8px 0 4px;
}

.subTitle {
	height: 12px;
	font-size: 12px;
	font-family: SourceHanSansCN-Normal, SourceHanSansCN;
	font-weight: 400;
	color: #666666;
	text-transform: uppercase;
}

.synopsis {
	width: 1200px;
	margin: 84px auto 67px;
	text-align: center;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
}

.text {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
}
.synopsis .content {
	width: 932px;
	font-size: 14px;
	font-family: SourceHanSansCN-Normal, SourceHanSansCN;
	font-weight: 400;
	color: #666666;
	line-height: 22px;
	margin: 19px 0 29px;
}

.architecture {
	width: 1200px;
	margin: 0 auto;
	padding: 86px 0 52px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
}

.system {
	width: 1200px;
	padding: 114px 91px 62px;
	box-sizing: border-box;
	margin: 0 auto;
}

.system .environment {
	padding: 68px 0 98px;
	border-bottom: 1px solid #D9D9D9;
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.info .title {
	height: 24px;
	font-size: 24px;
	font-family: SourceHanSansCN-Medium, SourceHanSansCN;
	font-weight: 500;
	color: #333333;
	margin-bottom: 34px;
}

.info  .content {
	width: 455px;
	font-size: 14px;
	font-family: SourceHanSansCN-Normal, SourceHanSansCN;
	font-weight: 400;
	color: #333333;
	line-height: 23px;
}

.control {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding-top: 49px;
}

	
.benefits {
	width: 1200px;
	margin: 0 auto;
	padding-top: 121px;
}

.plan {
	margin: 132px auto 135px;
	width: 1200px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
}
</style>